import { useEffect } from 'react';
import { preloadVideo } from '@remotion/preload';
import { TrackType } from '../../types/Track/Type';
import { SegmentsTrack } from '../../types/Track/SegmentsTrack';
import { SegmentType } from '../../types/Segment/Type';

export const usePreloadRemotionAssets = ({ playerConfig }) => {
  useEffect(() => {
    const segmentsTrack = playerConfig?.playerConfig.tracks.find(t => t.type === TrackType.SEGMENTS) as SegmentsTrack;
    const segments = segmentsTrack?.segments;

    if (!segments) return;
    // Track all video URLs that need to be preloaded
    const videosToPreload: string[] = [];

    // Collect video URLs from all segments
    segments.forEach(segment => {
      if (segment.type === SegmentType.VIDEO && segment.video) {
        videosToPreload.push(segment.video.details.preview || segment.video.details.src);
      } else if (segment.type === SegmentType.COMPOSITE) {
        const videos = segment.videos;
        videos.forEach(video => {
          videosToPreload.push(video.details.preview || video.details.src);
        });
      }
    });

    // Preload all collected videos
    const preloadInstances = videosToPreload.map(videoUrl => preloadVideo(videoUrl));

    // Cleanup function to cancel all preloads when component unmounts
    return () => {
      preloadInstances.forEach(unPreload => {
        unPreload();
      });
    };
  }, [playerConfig.durationInFrames, playerConfig?.playerConfig.tracks]);
};
